interface ICategory {
    id: number;
    consentGiven: boolean;
}

interface IConsentDetail {
    apiVersion: number;
    stored: boolean;
    date: string;
    categories: ICategory[];
}

export interface IConsent {
    schemaVersion: number;
    content: {
        brand: number;
        consents: IConsentDetail[];
    };
}

export enum ConsentType {
    Necessary = 1,
    Advertising = 3,
    Functionality = 4
}
